(function (angular) {
    'use strict';

    angular.module('profiles')

        /**
         *
         */
        .factory('profilesService',
            ['$http', '$q', 'portalConfig', 'profileData',
                function ($http, $q, portalConfig, profileData) {
                    var _profileConfig;
                    var urlBase = portalConfig.urlBase;
                    // urlBase = "http://localhost:8002";
                    var fac = {
                        addProfile: addProfile,
                        getProfiles: getProfiles,
                        getProfilesWithQueries: getProfilesWithQueries,
                        getProfile: getProfile,
                        getProfileDirect: getProfileDirect,
                        getProfileSchema: getProfileSchema,
                        updateProfile: updateProfile,
                        profileOptOut: profileOptOut,
                        profileOptIn: profileOptIn,
                        exportResults: exportResults,
                        importProfiles: importProfiles,
                        patchProfile: patchProfile,
                        getProfilesCount: getProfilesCount,
                        linkProfile: linkProfile,
                        deleteProfile: deleteProfile,
                        getProfilesOptInConfig: getProfilesOptInConfig,
                        setProfilesOptInConfig: setProfilesOptInConfig,
                        getHistory: getHistory,
                        createImport: createImport,
                        uploadAndGetPreview: uploadAndGetPreview,
                        checkDuplicates: checkDuplicates,
                        startImport: startImport,
                        getImportDetails: getImportDetails,
                        forgetProfile: forgetProfile
                    };

                    return fac;

                    function getImportDetails(apiSpaceId, importId, type) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/profiles/imports/" + importId + "/details?status=" + type)
                            .then(function (response) {
                                return response.data;
                            }).catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }
                    function profileOptOut(apiSpaceId, profileId, data) {
                        var channels = "";
                        for (var index in data.channels) {
                            channels = channels + "channel=" + data.channels[index] + "&";
                        }
                        channels = channels.slice(0, -1);
                        return $http.delete(urlBase + "/apispaces/" + apiSpaceId + "/profiles/" + encodeURIComponent(profileId) + "/optin?" + channels)
                            .then(function (response) {
                                return response.data;
                            }).catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }

                    function profileOptIn(apiSpaceId, profileId, data) {
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/profiles/" + encodeURIComponent(profileId) + "/optin", data)
                            .then(function (response) {
                                return response.data;
                            }).catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }

                    function getProfilesOptInConfig(apiSpaceId) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/profiles/optin")
                            .then(function (response) {
                                return response.data;
                            }).catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }

                    function setProfilesOptInConfig(apiSpaceId, data) {
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/profiles/optin", data)
                            .then(function (response) {
                                return response.data;
                            }).catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }

                    function startImport(apiSpaceId, importId, data) {
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/profiles/import/" + importId + "/start", data)
                            .then(function (response) {
                                return response.data;
                            })
                            .catch(function (error) {
                                return $q.reject(error);
                            });
                    }

                    function checkDuplicates(apiSpaceId, importId, matchBy) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/profiles/import/" + importId + "/duplicates?matchby=" + matchBy)
                            .then(function (response) {
                                return response.data;
                            })
                            .catch(function (error) {
                                return $q.reject(error);
                            });
                    }

                    function uploadAndGetPreview(apiSpaceId, importId, data, fileType) {
                        var fd = new FormData();
                        fd.append('file', data);
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/profiles/import/" + importId + "/upload?filetype=" + fileType, fd, {
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }
                        })
                            .then(function (response) {
                                return response.data;
                            })
                            .catch(function (error) {
                                return $q.reject(error);
                            });
                    }

                    function createImport(apiSpaceId) {
                        return $http.post(urlBase + "/apispaces/" + apiSpaceId + "/profiles/import")
                            .then(function (response) {
                                return response.data;
                            })
                            .catch(function (error) {
                                return $q.reject(error);
                            });
                    }

                    function getHistory(id) {
                        return $http.get(urlBase + "/apispaces/" + id + "/profiles/imports")
                            .then(getHistoryComplete)
                            .catch(getHistoryFailed);

                        function getHistoryComplete(response) {
                            return response.data;
                        }

                        function getHistoryFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * PATCH "/apispaces/{id}/profiles/{profileId}"
                     * @param {string} id - the api space Id
                     * @param {string} profileId - the profile id
                     * @param {string} profile - data of profile to 
                     * @param {array} propertiesToDelete - properties patch to delete
                     */
                    function patchProfile(id, profileId, profile, propertiesToDelete) {
                        var queryString = "";
                        if (propertiesToDelete && propertiesToDelete.length) {
                            queryString += "?";
                            for (var patch of propertiesToDelete) {
                                queryString += "deletes=" + patch + "&"
                            }
                            queryString = queryString.slice(0, -1);
                        }

                        return $http.patch(urlBase + "/apispaces/" + id + "/profiles/" + encodeURIComponent(profileId) + queryString, profile)
                            .then(patchProfileComplete)
                            .catch(patchProfileFailed);

                        function patchProfileComplete(response) {
                            return response.data;
                        }

                        function patchProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * POST "/apispaces/{id}/profiles"
                     * @param {string} id - the api space Id
                     * @param {object} data - profile data
                     */
                    function addProfile(id, data) {

                        return $http.post(urlBase + "/apispaces/" + id + "/profiles", data)
                            .then(addProfileComplete)
                            .catch(addProfileFailed);

                        function addProfileComplete(response) {
                            return response.data;
                        }

                        function addProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }
                    /**
                     * GET "/apispaces/{id}/profiles"
                     * @param {string} id - the api space Id
                     */
                    function getProfiles(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/profiles")
                            .then(getProfilesComplete)
                            .catch(getProfilesFailed);

                        function getProfilesComplete(response) {
                            return response.data;
                        }

                        function getProfilesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    function deleteProfile(id, profileId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/profiles/" + encodeURIComponent(profileId))
                            .then(deleteProfileComplete)
                            .catch(deleteProfileFailed);

                        function deleteProfileComplete(response) {
                            return response.data;
                        }

                        function deleteProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    function forgetProfile(id, profileId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/profiles/" + encodeURIComponent(profileId) + "?forget=true")
                            .then(forgetProfileComplete)
                            .catch(forgetProfileFailed);

                        function forgetProfileComplete(response) {
                            return response.data;
                        }

                        function forgetProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * GET "/apispaces/{id}/profiles?extension"
                     * @param {string} id - the api space Id
                     * @param {string} extension - the queries extension
                     */
                    function getProfileSchema(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/profiles?$schemaOnly=true")
                            .then(getProfileSchemaComplete)
                            .catch(getProfileSchemaFailed);

                        function getProfileSchemaComplete(response) {
                            return response.data;
                        }

                        function getProfileSchemaFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * GET "/apispaces/{id}/profiles?extension"
                     * @param {string} id - the api space Id
                     * @param {string} extension - the queries extension
                     */
                    function getProfilesWithQueries(id, extension, async) {

                        return $http.get(urlBase + "/apispaces/" + id + "/profiles?" + extension, { async: async })
                            .then(getProfilesWithQueriesComplete)
                            .catch(getProfilesWithQueriesFailed);

                        function getProfilesWithQueriesComplete(response) {
                            return response.data;
                        }

                        function getProfilesWithQueriesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * GET "/apispaces/{id}/profiles?id=profileId"
                     * @param {string} id - the api space Id
                     * @param {string} profileId - the profile Id
                     */
                    function getProfile(id, profileId, async) {
                        if (/^\d+$/.test(profileId)) {
                            profileId = "'" + profileId + "'";
                        }
                        return $http.get(urlBase + "/apispaces/" + id + "/profiles?id=" + encodeURIComponent(profileId) + "&$includeDevices=true&$includeSessions=true", { async: async })
                            .then(getProfileComplete)
                            .catch(getProfileFailed);

                        function getProfileComplete(response) {
                            return response.data[0];
                        }

                        function getProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * GET "/apispaces/{id}/profiles/{profileId}"
                     * @param {string} id - the api space Id
                     * @param {string} profileId - the profile Id
                     */
                    function getProfileDirect(id, profileId, async) {
                        return $http.get(urlBase + "/apispaces/" + id + "/profiles/" + encodeURIComponent(profileId) + "?includeLastActivityOn=true&includeLastChannelActivity=true", { async: async })
                            .then(getProfileComplete)
                            .catch(getProfileFailed);

                        function getProfileComplete(response) {
                            profileData.profile = response.data;
                            return response.data;
                        }

                        function getProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * PUT "/apispaces/{id}/profiles/{profileId}"
                     * @param {string} id - the api space Id
                     * @param {string} profile - data of profile to update
                     */
                    function updateProfile(id, profile) {

                        return $http.put(urlBase + "/apispaces/" + id + "/profiles/" + encodeURIComponent(profile.id), profile)
                            .then(updateProfileComplete)
                            .catch(updateProfileFailed);

                        function updateProfileComplete(response) {
                            return response.data;
                        }

                        function updateProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * PUT "/apispaces/{id}/profiles/{profileId}"
                     * @param {string} id - the api space Id
                     * @param {string} extension - the queries extension
                     * @param {string} data - options for query
                     */
                    function exportResults(id, extension, data) {

                        return $http.post(urlBase + "/apispaces/" + id + "/profiles/export?" + extension, data)
                            .then(exportResultsComplete)
                            .catch(exportResultsFailed);

                        function exportResultsComplete(response) {
                            return response.data;
                        }

                        function exportResultsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function importProfiles(pickedApiSpaceId, data) {
                        return $http.post(urlBase + '/apispaces/' + pickedApiSpaceId + "/profiles/import", data)
                            .then(importProfilesComplete)
                            .catch(importProfilesFailed);

                        function importProfilesComplete(response) {
                            return response.data;
                        }

                        function importProfilesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getProfilesCount(id, extension) {
                        extension = extension ? "?" + extension : "";
                        return $http.get(urlBase + "/apispaces/" + id + "/profiles/count" + extension)
                            .then(getProfilesCountComplete)
                            .catch(getProfilesCountFailed);

                        function getProfilesCountComplete(response) {
                            return response.data;
                        }

                        function getProfilesCountFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * PUT /apispaces/{apiSpaceId}/profiles/{id}/rels/primary/{linkedId} 
                     * Creates a relationship to a primary profile
                     * @param {string} id - the api space Id
                     * @param {string} profileId - the primary profile
                     * @param {string} linkedId - The id of the profile to link with
                     */
                    function linkProfile(id, profileId, linkedId) {

                        return $http.put(urlBase + "/apispaces/" + id + "/profiles/" + encodeURIComponent(profileId) + "/rels/primary/" + linkedId)
                            .then(linkProfileComplete)
                            .catch(linkProfileFailed);

                        function linkProfileComplete(response) {
                            return response.data;
                        }

                        function linkProfileFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);
})(window.angular);
